export class CacheRequest { 
    public idProject: number;
    public cacheName: string;
    public cacheValue: string;
    public idHealthUnit: number;
}